export default __webpack_public_path__ + "static/media/ic-warning.54ab11a6.svg";